import { Button } from '../../../components/ui';
import { Alert } from '../../../models/view';
import { generateShortUUID, openUrl } from '../../../utils';

export const makePreAssessmentAlert = (preAssessmentUrl: string): Alert => ({
  id: generateShortUUID(),
  type: 'success',
  title: 'Take the Pre-Assessment',
  message: () => <Button text="Open" color="secondary" onPress={() => openUrl(preAssessmentUrl)} />,
  canClose: false,
});
